import { render } from "./TableList.vue?vue&type=template&id=66dee7f6&scoped=true&ts=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=66dee7f6&lang=scss"
import "../assets/scss/table-list.scss?vue&type=style&index=1&id=66dee7f6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dee7f6"]])

export default __exports__